import { ApiError } from '../api/errors'
export function securityMessage(error: ApiError): string {
  const messages: Record<string, string> = {
    captcha_required: 'تأیید امنیتی را انجام دهید.',
    captcha_invalid: 'تأیید امنیتی معتبر نیست. دوباره آن را انجام دهید.',
    captcha_unavailable: 'تأیید امنیتی در دسترس نیست. کمی بعد دوباره تلاش کنید.',
    security_unavailable: 'سامانهٔ محافظت ورود در دسترس نیست. کمی بعد دوباره تلاش کنید.',
    temporarily_blocked: 'ورود موقتاً محدود شده است.',
    rate_limited: 'درخواست‌های بیش از حد. کمی بعد دوباره تلاش کنید.',
    otp_resend_too_soon: 'برای ارسال دوبارهٔ کد کمی صبر کنید.',
    otp_attempts_exceeded: 'تلاش‌های تأیید بیش از حد است. پس از پایان محدودیت کد تازه بگیرید.',
  }
  const text = messages[error.code] ?? error.message
  return error.retryAfter ? `${text} حدود ${error.retryAfter.toLocaleString('fa-IR')} ثانیه دیگر دوباره تلاش کنید.` : text
}
